import { Component, computed, input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'era-active-device-syncs-progress-bar-ui',
  templateUrl: './active-device-syncs-progress-bar.component.html',
  styleUrls: ['./active-device-syncs-progress-bar.component.scss'],
  imports: [NgbTooltip],
})
export class ActiveDeviceSyncsProgressBarComponent {
  readonly maximumActiveDeviceSyncs = input.required<number>();
  readonly currentActiveDeviceSyncs = input.required<number>();

  readonly activeDeviceSyncsPercentage = computed(() => {
    const max = this.maximumActiveDeviceSyncs();
    const current = this.currentActiveDeviceSyncs();

    if (current == undefined || max == undefined) {
      return 0;
    }

    return (current / max) * 100;
  });
}
